export const splitNumber = (x: number | string) => {
  const sX = String(x);
  if (sX.length < 5) {
    return sX;
  }
  const splitted = sX.split('').reverse();
  const groupped = [];
  for (let i = 0; i < splitted.length; i += 3) {
    groupped.push(
      `${splitted[i] || ''}${splitted[i + 1] || ''}${splitted[i + 2] || ''}`
        .split('')
        .reverse()
        .join('')
    );
  }
  return groupped.reverse().join(' ');
};

export const formatLiveDataBets = (betsRange: string) => {
  const minMaxBets = betsRange.split('-');
  const minMaxBetsNumbers = minMaxBets.map((numString) => {
    const formattedNumStr = numString.replace(/\s+/g, '');
    const number = parseFloat(formattedNumStr);
    if (number < 10) {
      return number;
    }
    return parseInt(formattedNumStr, 10);
  });
  if (minMaxBetsNumbers.some((num) => Number.isNaN(num))) {
    return betsRange;
  }
  if (minMaxBetsNumbers.every((num) => num >= 1000)) {
    return minMaxBetsNumbers.map((num) => `${num / 1000}K`).join(' - ');
  }
  return minMaxBetsNumbers.map((num) => splitNumber(num)).join(' - ');
};
